import React from 'react';
import styles from "../styles/Footer.module.css";

const Footer = () => {
  return (
    <footer className={`${styles.footer} ${styles.flush}`} role="contentinfo">
      <div className={styles.inner}>
        {/* 회사 정보 */}
        <div className={styles.block}>
          <h4 className={styles.blockTitle}>주식회사 메타에이아이(MetaAI Corp.)</h4>

          <p className={styles.row}>
            <span className={styles.value}>
              서울 강서구 공항대로 237, 1207호(마곡동, 에이스타워마곡)
            </span>
          </p>

          <div className={styles.contactLine}>
            <span className={styles.badge}>Tel</span>
            <span className={styles.value}>070-7585-0045</span>

            <span className={styles.sep} />

            <span className={styles.badge}>Fax</span>
            <span className={styles.value}>0504-018-7998</span>
          </div>
        </div>
      </div>
  
      <div className={styles.bottom}>
        <p className={styles.copy}>
          Copyright © MetaAI. All Rights Reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer